module.exports = {
  extensions: ['.png', '.jpg', '.jpeg', '.pdf'],
  mimetypes: ['application/pdf', 'application/x-pdf', 'image/jpeg', 'image/pjpeg', 'image/x-citrix-jpeg', 'image/png'],
  fileSize: 4194304 // 4 MB

};